var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8 16h-28c-.5 0-1-.4-1-1 0-.5.4-1 1-1h28c.5 0 1 .4 1 1s-.4 1-1 1zM38.8 25h-28c-.5 0-1-.4-1-1 0-.5.4-1 1-1h28c.5 0 1 .4 1 1 0 .5-.4 1-1 1zM38.8 34h-28c-.5 0-1-.4-1-1 0-.5.4-1 1-1h28c.5 0 1 .4 1 1 0 .5-.4 1-1 1z"
  })));
};
export default SvgHamburger;